import type { Product } from '../../../data/product';
import { compare } from '../../../helpers/column-sort';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const VendorName: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Vendor Name',
  minWidth: 150,
  maxWidth: 264,
  accessorFn: (product) => product.vendor_name,
  sortingFn: (rowA, rowB) => compare(rowA.vendor_name, rowB.vendor_name),
});
